import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Table, Tag, Popconfirm } from 'antd';
import PropTypes from 'prop-types';
import { getQuizStudentAnswers } from '../actions';
import {toastr} from 'react-redux-toastr'

class Report extends Component {
  static contextTypes = {formatMessage: PropTypes.any}


  studentAnswer = async (record) => {
    const {formatMessage} = this.context;
    try {
      const {quiz} = this.props;
      await this.props.getQuizStudentAnswers(quiz.id, record.student.id, formatMessage)
    } catch (error) {
    }
  }

  render() {
    const {formatMessage} = this.context;

    const {data, quiz} = this.props;
    if(!quiz){
      return null;
    }
    const columns = [
      {
        title: formatMessage('tableReportFirstLastName'),
        // dataIndex: 'first_last_name',
        key: 'first_last_name',
        render: item => item.student.firstname + ' ' + item.student.lastname
      },
      {
        title: formatMessage('tableReportTotalAnswers'),
        dataIndex: 'total_answer',
        key: 'total_answer',
      },
      {
        title: formatMessage('tableReportMinScore'),
        dataIndex: 'min_score',
        key: 'min_score',
      },
      {
        title: formatMessage('tableReportMaxScore'),
        dataIndex: 'max_score',
        key: 'max_score',
      },
      {
        title: formatMessage('tableReportAverage'),
        dataIndex: 'average',
        key: 'average',
      },
    ];
    return (
      <div className="ReportTable"> 
        <div>{formatMessage('titleScorePerformance')}:</div>
        <Table 
          dataSource={data} 
          columns={columns} 
          bordered 
          pagination={false}
          onRow={(record, rowIndex) => {
            return {
              onClick: () => this.studentAnswer(record), // click row
            };
          }}
        /> 
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => ({
  data: state.statistic_report.quiz_statistic,
  quiz: state.statistic_report.quiz,
})

const mapDispatchToProps = {
  getQuizStudentAnswers
}

export default connect(mapStateToProps, mapDispatchToProps)(Report)



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/StatisticReports/Report/index.jsx